// src/services/api.js
import axios from 'axios';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 400 && error.response.data.message === 'Invalid token.') {
      localStorage.removeItem('token');
      history.push('/login');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default api;
